import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import PageSection from './PageSection';

import s from './Page.css';

class Page extends React.Component {
  static propTypes = {
    html: PropTypes.string,
    title: PropTypes.string,
    lead: PropTypes.string,
  };

  static defaultProps = {
    html: '',
    title: '',
    lead: '',
  };

  render() {
    const { title, lead, html } = this.props;

    return (
      <PageSection>
        <div className={s.root}>
          <div className={s.container}>
            {title ? <h1 className={s.title}>{title}</h1> : null}
            {lead ? <p className={s.lead}>{lead}</p> : null}
            {html ? (
              <div
                className={s.content}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ) : null}
          </div>
        </div>
      </PageSection>
    );
  }
}

export default withStyles(s)(Page);



// WEBPACK FOOTER //
// ./src/components/Page/Page.js